import { Controller } from 'stimulus';

// Reloads the <turbo-frame> around it from the frame's `src` every `interval` ms, for a panel that
// reports a background job's progress. Put it on an element inside the frame, not on the frame itself:
// a reload replaces the frame's contents but keeps its attributes, so the server stops the polling by
// rendering the contents without this element once the job is done.
export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 } };

  connect() {
    this.timer = setInterval(() => this.reload(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  reload() {
    const frame = this.element.closest('turbo-frame');
    if (document.hidden || !frame || !frame.src) return;

    frame.reload();
  }
}
